module.exports = __webpack_public_path__ + "static/img/img_form_2@2x_ko.d2b3c11b.png";